import { useTexts } from '@/contexts/LanguageContext'
import { cn } from '@/lib/utils'

const LOGO_MASK = {
  maskImage: 'url(/logo.svg)',
  maskRepeat: 'no-repeat',
  maskPosition: 'center',
  maskSize: 'contain',
}

export default function PoweredBy({ className, logoClassName }: { className?: string; logoClassName?: string }) {
  const { NAV } = useTexts().PUBLIC_TRUST_CENTER
  return (
    <span className={cn('items-center gap-2 text-xs text-trust-center-muted', className)}>
      {NAV.POWERED_BY}
      <span role="img" aria-label="Qalea" className={cn('block h-4 w-16', logoClassName)} style={LOGO_MASK} />
    </span>
  )
}
